import "./providers";
import { getActiveProvider } from "./registry";
import type { AnalyticsIdentifyContext } from "./types";

export async function identifyUser(context: AnalyticsIdentifyContext): Promise<void> {
  await getActiveProvider()?.identify(context);
}

export async function resetAnalyticsUser(): Promise<void> {
  await getActiveProvider()?.reset();
}
